module.exports = __webpack_public_path__ + "static/media/PFDinTextPro-Bold.a8f85194.ttf";